import React from "react";
import { useLocalStorage } from "usehooks-ts";

type TContext = {
  isLogin: boolean;
  toggleLogin: () => void;
  login: () => void;
  logout: () => void;
};

const LoginContext = React.createContext<TContext>({
  isLogin: false,
  toggleLogin: () => {},
  login: () => {},
  logout: () => {},
});

export const LoginContextProvider: React.FC = (props) => {
  const [isLogin, setIsLogin] = useLocalStorage("isLogin", false);

  function toggleLogin() {
    setIsLogin((prev) => !prev);
  }

  function login() {
    // Write storage immediately so a same-tick navigate sees authenticated state
    window.localStorage.setItem("isLogin", JSON.stringify(true));
    setIsLogin(true);
  }

  function logout() {
    setIsLogin(false);
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("username");
  }

  const loginValue: TContext = {
    isLogin: isLogin,
    toggleLogin: toggleLogin,
    login,
    logout,
  };

  return (
    <LoginContext.Provider value={loginValue}>
      {props.children}
    </LoginContext.Provider>
  );
};

export default LoginContext;
